<template>
  <div class="html" v-html="html"></div>
</template>

<script>
export default {
  name: 'HtmlBlock',
  props: {
    html: {
      type: String,
      defaultValue: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.html {
  font-size: 1.15rem;
}
</style>
